import { GuideWidget } from "../embed/pages/GuideWidget";
import { API_BASE, STORE_ID } from "../lib/chatApi";

function Guide() {
  return (
    <div className="w-full min-h-screen" style={{ background: "var(--color-background)" }}>
      <GuideWidget storeId={STORE_ID} apiBase={API_BASE} showMetadata={false} />
    </div>
  );
}

export default Guide;
